import axios from "../axiosInstance";

const commonAPI = {
  stateList: () => axios.get("common/state-list"),
  constituencyList: (payload) => axios.post("common/constituency-list", payload),
  vidhanSabhaList: (payload) => axios.post("common/vidhan-sabha-list", payload),
};

export default commonAPI;
